/**
 * King Living Slider Theme
 *
 * Global slider styling system supporting:
 * - Single value slider
 * - Dark brown/bronze filled track (brandColors.primaryDarkLinen)
 * - Light grey unfilled track (brandColors.greyscale10)
 * - White thumb with dark grey border (brandColors.greyscale)
 *
 * @override Extends Chakra UI Slider theme
 */

const Slider = {
  parts: ['container', 'track', 'filledTrack', 'thumb', 'mark'],
  baseStyle: {
    track: {
      bg: 'brandColors.greyscale10', // Light grey for unfilled track
      h: '4px', // Track height
      borderRadius: '4px',
    },
    filledTrack: {
      bg: 'brandColors.primaryDarkLinen', // Dark brown/bronze for filled track
    },
    thumb: {
      w: '14px', // 14px
      h: '14px', // 14px
      bg: 'white', // White background
      border: '1px solid',
      borderColor: 'brandColors.greyscale', // Dark grey border
      borderRadius: 'full', // Circular
      _focus: {
        boxShadow: 'none',
        outline: 'none',
      },
      _active: {
        boxShadow: 'none',
      },
    },
  },
};

export default Slider;
